import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Api } from '../../core/api/Api';

@Injectable({
  providedIn: 'root',
})
export class SustainabilityService {
  constructor(private http: HttpClient) {}

  fetchSustainabilityStatistics(from: Date, to: Date) {
    return this.http.get(Api.Sustainability, {
      params: {
        from: from.toISOString().slice(0, 10),
        to: to.toISOString().slice(0, 10),
      },
    });
  }

  fetchSustainabilityStatisticsAsCSV(from: Date, to: Date) {
    return this.http.get(Api.SustainabilityCSV, {
      params: {
        from: from.toISOString().slice(0, 10),
        to: to.toISOString().slice(0, 10),
      },
      responseType: 'text',
      observe: 'response',
    });
  }
}
